import 'babel-polyfill';
import { unregister } from './registerServiceWorker';
import React from 'react';
import ReactDOM from 'react-dom';
import { getProp } from './ui/src/utilities';

import 'react-image-lightbox/style.css';
import configureStore from './app/configureStore';
import { Provider } from 'react-redux';
import Routes from './app/Routes';
import { browserHistory } from 'react-router';
import { syncHistoryWithStore } from 'react-router-redux';

require('./app/app.css');
require('./ui/src/ui.css');

let defaultState = null;
let state = {};
if (typeof window !== 'undefined') {
  state = getProp(window, '__REDUX_STATE__');
}
const store = configureStore(
  state !== '{{SSR_INITIAL_STATE}}' ? state : defaultState,
);

let history = {};

if (typeof window !== 'undefined') {
  history = syncHistoryWithStore(browserHistory, store);
}

ReactDOM.render(
  <Provider store={store}>
    <Routes history={history} />
  </Provider>,
  document.getElementById('root'),
);
unregister();



// WEBPACK FOOTER //
// ./src/index.js